module.exports = __webpack_public_path__ + "static/media/zhiyezhuang.961d3d1b.png";